
import { mapState, mapGetters } from "vuex";
import ChannelOnlineStatusHandler from "../reciever/channel-online-status-handler.vue";

export default {
  props: {
    channel: {},
    isAllChannelCol: false
  },
  components: { ChannelOnlineStatusHandler },
  computed: {
    ...mapState("reciever", ["recieverSettings", "selectedChannel"]),
    ...mapGetters("reciever", ["getChannelAllOrders"]),
    ...mapGetters("restaurant", ["getAllBrands", "hasMultipleBrands"]),
    isChannelOnline() {
      return !this.channel.restaurants.some((restaurant) =>
        restaurant.restaurant_platforms.some(
          (platform) =>
            platform.platform_name === this.channel.name &&
            platform.state !== "online"
        )
      );
    },

    channelAllOrders() {
      return this.getChannelAllOrders(this.channel.name);
    }
  }
};
